<template>
    <div class="flex items-center">
        <a v-if="row.links.show" :href="row.links.show" class="mr-2 hover:text-red-100">
            <Icon name="eye" />
        </a>
        <a v-if="row.links.edit" :href="row.links.edit" class="mr-2">
            <Icon name="edit-3" />
        </a>
        <button v-if="row.links.destroy" @click="$emit('delete')">
            <Icon name="trash-2" />
        </button>
    </div>
</template>

<script>
    export default {
        name: 'TableLinks',
        props: {
            row: {
                type: Object,
                required: true,
            },
        },
    };
</script>
